import React, {useState} from "react";
import {Button, Row, Col, Modal, Input, Typography} from "antd";
import '../modals.css';
import i18n from '../../../i18n';

export default function ModalSendComment({
                                           isShow,
                                           sendMethod,
                                           setIsShow,
                                           setNeedUpdateList
                                         }) {

  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };
  const {Text} = Typography;
  const {TextArea} = Input;
  const [comment, setComment] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  return (<Modal
    title={<div>{i18n.t('modals.modalSendComment.title')}</div>}
    cancelText={i18n.t('main.buttons.close')}
    className="modal-window"
    align={null}
    visible={isShow}
    onCancel={() => {
      setIsShow(false);
    }}
    forceRender={true}
    footer={
      <Button htmlType="submit" key="submit" type="primary"
              style={bigButtonStyle}
              onClick={() => sendMethod(comment)}
              disabled={comment === "" || isDisabled}
      >{i18n.t('main.buttons.send')}</Button>
    }
  >
    <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
      <Col span={24}>
        <TextArea
          placeholder={i18n.t('modals.modalSendComment.fields.comment.placeholder')}
          value={comment}
          onChange={(e) => {
            setComment(e.target.value)
          }}
          rows={4}
          autoSize={{minRows: 4, maxRows: 8}}
          style={{marginTop: "20px"}}
        />
      </Col>
    </Row>
  </Modal>);
}
